




























import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import LogoutModal from '@/components/modals/LogoutModal.vue';
import LoginFailedModal from '@/components/modals/LoginFailedModal.vue';
import userx from './store/modules/userx';
import { SignLinkError } from './store/firestore';
import LoadingPage from './components/ui/LoadingPage.vue';
import { Global } from './store/globalz';
import globalx from './store/modules/globalx';
import MaintenancePage from './components/ui/MaintenancePage.vue';
import { Analytics } from '@/client/analytics';
import OverlayComponent from '@/components/ui/OverlayComponent.vue';
import ContextMenu from './components/ui/ContextMenu.vue';
import ConvertDuplicatesModal from './components/gacha/ConvertDuplicatesModal.vue';
import GachaListener from './components/gacha/GachaListener.vue';
import PoqLinkModal from './components/gacha/poq/PoqLinkModal.vue';
import ShopModal from './components/gacha/poq/ShopModal.vue';
import ConvertAllDuplicatesModal from './components/gacha/ConvertAllDuplicatesModal.vue';
import SkinIntelToolTip from './components/gacha/SkinIntelTooltip.vue';

const sheet = document.createElement('style');
sheet.type = 'text/css';
(document.head || document.getElementsByTagName('head')[0]).appendChild(sheet);
function setStyle(cssText: string, node?: Text) {
  if (!node || node.parentNode !== sheet) {
    return sheet.appendChild(document.createTextNode(cssText));
  }
  node.nodeValue = cssText;
  return node;
}

const theCss = setStyle('.modal{transform:scale(1) !important;}');

@Component({
  components: {
    ShopModal,
    LogoutModal,
    LoginFailedModal,
    LoadingPage,
    MaintenancePage,
    OverlayComponent,
    ContextMenu,
    ConvertDuplicatesModal,
    ConvertAllDuplicatesModal,
    GachaListener,
    PoqLinkModal,
    SkinIntelToolTip,
  },
})
export default class App extends Vue {
  public get hasMaintenance() {
    return (
      process.env.NODE_ENV !== 'development' &&
      location.hostname !== 'test8845.stabfish2.io' &&
      (globalx.maintenanceInfo?.ongoing || globalx.forceUpdate || false)
    );
  }
  public get gameUrl() {
    return this.$route.query.back as string;
  }
  @Watch('gameUrl', { immediate: true })
  public onGameUrlChanged(value: string) {
    if (value && !Global.gameUrl) {
      Global.gameUrl = value;
    }
  }

  public async mounted() {
    // DataServerApiTest.test();
    this.$root.$on('error', this.showError);
    Global.$root = this.$root;
    Global.$bvModal = this.$bvModal;
    Global.partner = (this.$route.query.p as string) || '';
    Analytics.visit();
    this.resize();
    window.addEventListener('resize', this.resize.bind(this));
  }

  public resize() {
    const appScale = Global.appScale;
    const width = (1 / appScale) * 100;
    const div = this.$el as HTMLDivElement;
    div.style.transformOrigin = 'top left';
    div.style.transform = `scale(${appScale})`;
    div.style.width = `${width}%`;
    div.style.height = `${width}%`;
    setStyle(
      `.modal{transform:scale(${appScale}) !important; width:${width}% !important; height:${width}% !important;}
       .b-toaster{transform:scale(${appScale}) !important; width:calc(${width}% - 1rem) !important;}
      `,
      theCss,
    );
  }

  public showError(error: any) {
    this.$bvModal.msgBoxOk((error as any).message || error, {
      titleHtml: `<i class="fa fa-exclamation-triangle"></i> Error`,
      size: 'sm',
      buttonSize: 'sm',
      okVariant: 'danger',
      modalClass: 'funny-modal',
    });
  }

  public get signLinkError() {
    return userx.signLinkError;
  }
  @Watch('signLinkError', { immediate: true })
  public signLinkErrorChanged(newVal: SignLinkError | null) {
    if (newVal) {
      this.$root.$emit('signLinkError', newVal);
    }
  }
}
